import ReactDOM from 'react-dom';
import $ from 'jquery';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { isEqual } from 'lodash/fp';
import { inspect } from '@xstate/inspect';

import store from '~/state';
import { createQuerySubscription } from '~/utils';
import { authService, AuthProvider } from './containers/Auth';

export const queryClient = new QueryClient();

export const querySubscription = createQuerySubscription(queryClient);

const DEV_MODE = ['staging', 'development'].some(isEqual(process.env.NODE_ENV));

/**
 * Given a parent container element and a react element, renders the element
 * within the parent and allows react to take over the contents of said
 * container. The supplied parent can be any of a native DOM element, a jQuery
 * wrapped selector, or a string selector.
 * @param {DOMElement | string | jQuery} parent - The container parent element
 * in which to render the React content.
 * @param {ReactElement} component - A React element, such as <div />.
 * @returns {ReactElement} - A reference to the rendered parent container
 * element as a react component. Not recommended for use.
 */

let devtoolsMounted = false;

export const render = (parent, component) => {
  const wrappedComponent = (
    <Provider store={store}>
      <AuthProvider service={authService}>
        <QueryClientProvider client={queryClient}>
          { component }
          { !devtoolsMounted && DEV_MODE && <ReactQueryDevtools initialIsOpen={false} /> }
        </QueryClientProvider>
      </AuthProvider>
    </Provider>
  );

  if (!parent) {
    throw new Error(`No parent supplied to render; could not mount component ${component}`);
  }

  if (typeof parent === 'string' && $(parent).length === 1) {
    ReactDOM.render(wrappedComponent, $(parent).get(0));
  }

  if (parent instanceof $) {
    ReactDOM.render(wrappedComponent, parent.get(0));
  }

  devtoolsMounted = true;
};
